<router-outlet></router-outlet>

<app-support-line></app-support-line>
<!-- <lib-cc-support-line></lib-cc-support-line> -->